import { render } from "./ButtonControls.vue?vue&type=template&id=bff38e1e"
import script from "./ButtonControls.vue?vue&type=script&lang=js"
export * from "./ButtonControls.vue?vue&type=script&lang=js"

import "./ButtonControls.vue?vue&type=style&index=0&id=bff38e1e&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__